import { FridgeIcon } from './FridgeIcon';

/**
 * author: Simran
 * id 148520BB-2172-4261-9336-3E85E5131869
 * name fridge
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fridge.svg
 * tags
 * - Home Automation 
 */
export const RefrigeratorIcon = FridgeIcon;
export default RefrigeratorIcon